import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import {
  PlayService,
  PlayablePairsResponse,
  PlayableWordsResponse,
} from '../../../service/play/play.service'
import { Pair } from '../../models/main/pair'
import { Word } from '../../models/main/word'
import { DdcFlashCardComponent } from '../ddc-flash-card/ddc-flash-card.component'
import { DdcLoadingSkeletonComponent } from '../ddc-loading-skeleton/ddc-loading-skeleton.component'

@Component({
  selector: 'ddc-flashcard-page',
  templateUrl: './ddc-flashcard-page.component.html',
  styleUrls: ['./ddc-flashcard-page.component.scss'],
  imports: [
    AngularMaterialsModules,
    CommonModule,
    DdcFlashCardComponent,
    DdcLoadingSkeletonComponent,
  ],
})
export class DdcFlashcardPageComponent implements OnInit {
  dictionaryId!: number
  type: 'words' | 'pairs' = 'words'
  items: (Word | Pair)[] = []
  loading = true
  error: string | null = null
  currentIndex = 0
  isFlipped = false

  constructor(
    private route: ActivatedRoute,
    private playService: PlayService,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('dictionaryId')
      const type = params.get('type') as 'words' | 'pairs'
      console.log('Received params:', { id, type }) // Debug log
      if (id && type) {
        this.dictionaryId = +id
        this.type = type
        this.fetchItems()
      } else {
        this.error = 'Invalid parameters.'
        this.loading = false
      }
    })
  }

  fetchItems(): void {
    this.loading = true
    if (this.type === 'words') {
      this.playService.getPlayableWords(this.dictionaryId, 1, 10).subscribe({
        next: (res: PlayableWordsResponse | null) => {
          this.items = res?.results || []
          this.loading = false
        },
        error: () => {
          this.error = 'Failed to load words.'
          this.loading = false
        },
      })
    } else {
      this.playService.getPlayablePairs(this.dictionaryId, 1, 10).subscribe({
        next: (res: PlayablePairsResponse | null) => {
          this.items = res?.results || []
          this.loading = false
        },
        error: () => {
          this.error = 'Failed to load pairs.'
          this.loading = false
        },
      })
    }
  }

  nextCard(): void {
    if (this.currentIndex < this.items.length - 1) {
      this.currentIndex++
      this.isFlipped = false
    }
  }

  prevCard(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.isFlipped = false
    }
  }

  onCardClick(): void {
    this.isFlipped = !this.isFlipped
  }
}
